import { render, staticRenderFns } from "./veJkyProjectCount.vue?vue&type=template&id=2ebd36c9&scoped=true"
import script from "./veJkyProjectCount.vue?vue&type=script&lang=js"
export * from "./veJkyProjectCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebd36c9",
  null
  
)

export default component.exports